export default __webpack_public_path__ + "static/media/Mahabalipuram_liht house.dad9c50c.jpg";